import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Maximum number of free chats allowed for non-authenticated users
const MAX_FREE_CHATS = 5;

// FreeChatGuard component that allows a limited number of chats before authentication
const FreeChatGuard = ({ children, requireAuth = true }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = () => {
      const authToken = localStorage.getItem('authToken');
      
      // If user is authenticated, allow access
      if (authToken) {
        setIsAuthenticated(true);
        setIsLoading(false);
        return;
      }
      
      // If this component doesn't require authentication, allow access
      if (!requireAuth) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }
      
      // Even if requireAuth is true, we'll NOT redirect for chat limit enforcement
      // The chat limit is handled in the Chatconversation component
      setIsAuthenticated(false);
      setIsLoading(false);
    };
    
    checkAuthStatus();
    
    // Also check when local storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'authToken') {
        checkAuthStatus();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [navigate, requireAuth]);

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  // Always render children, chat limit is enforced in Chatconversation component
  return <>{children}</>;
};

export default FreeChatGuard; 